import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import * as Parse from 'parse';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-riskscore',
  templateUrl: './riskscore.component.html',
  styleUrls: ['./riskscore.component.css']
})
export class RiskscoreComponent implements OnInit {
  score : Number = Number(this.cookie.get("riskScore"));
  atRisk : boolean = false;
  risk : String;

  constructor(
    private router : Router,
    private _bkoffService : BackOffServiceService,
    private cookie : CookieService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
   }

  ngOnInit() {
    this.checkRisk();
    console.log(this.score);
  }

  checkRisk() {
    if (this.score >= 5) {
      this.atRisk = true;
    }
  }

  gotoHome(){
    this.cookie.deleteAll();
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
  contactShortly(){
    //this._bkoffService.setisEnrolled();
    //this.router.navigateByUrl('/motivationscore');
    this.router.navigateByUrl('/phoneandemail');
  }
  recommend(){
    this.router.navigateByUrl('/recommendRegister');
  }
}
